module.exports = __webpack_public_path__ + "img/new_index_cases2.0b4072ec.jpg";